// extracted by mini-css-extract-plugin
export var card = "_p4-0";
export var content = "_p4-2";
export var details = "_p4-3";
export var icon = "_p4-1";
export var iconBlue = "_p4-5";
export var iconBrand = "_p4-4";
export var iconGrayBlue = "_p4-6";
export var iconGreen = "_p4-7";
export var iconIndigo = "_p4-8";
export var iconOrange = "_p4-9";
export var iconPurple = "_p4-a";
export var iconRed = "_p4-b";
export var iconWarning = "_p4-c";